import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledCustomerReviews = {
  ReviewContainer: styled.div`
    margin-bottom: 16px;
    padding: 16px;
    background: #2b314d;
    border-radius: 20px;
  `,
  Rating: styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 98px;
    margin-bottom: 16px;

    svg {
      width: 18px;
      height: 18px;
    }
  `,
  Author: styled.div`
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${Color.WHITE};
  `,
  Text: styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${Color.LIGHT};

    svg {
      margin: 0 2px -4px;
    }
  `,
}
